module.exports = __webpack_public_path__ + "img/1275851144.d3dcc948.jpg";